import { log } from '../Observable.js';
import { Subscribable, UNKNOWN } from '../Subscribable.js';
class CombinedSubscribable extends Subscribable {
    constructor(...upstreams) {
        super();
        this.upstreams = upstreams;
        this.values = new Array(upstreams.length).fill(UNKNOWN);
        this.upstreamChangedCallback = this.upstreamChanged.bind(this);
    }
    get() {
        if (this.values.some(val => val === UNKNOWN)) {
            return UNKNOWN;
        }
        return this.values;
    }
    subscriptionsWillChange(hasSubscriptions) {
        // (un)subscribe from/to all upstreams
        for (const upstream of this.upstreams) {
            upstream[hasSubscriptions ? 'subscribe' : 'unsubscribe'](this.upstreamChangedCallback);
        }
    }
    upstreamChanged(value, observable) {
        let found = false;
        for (let i = 0; i < this.upstreams.length; i++) {
            if (this.upstreams[i] === observable) {
                this.values[i] = value;
                found = true;
            }
        }
        if (!found) {
            log.error('combine: observable', observable, 'not in list of upstreams', this.upstreams);
            return;
        }
        this.changed();
    }
}
/**
 * Returns a new observable from multiple existing observables.
 * Resolves as soon as all existing observables have a value and whenever one of them changes their value.
 * @param observables the observables to subscribe to
 * @returns an observable that emits an array of all values of the given observables.
 */
export function combine(...observables) {
    return new CombinedSubscribable(...observables);
}
